import { render } from "./Add_Alerte_SMS_Form.vue?vue&type=template&id=1b1e832c"
import script from "./Add_Alerte_SMS_Form.vue?vue&type=script&lang=js"
export * from "./Add_Alerte_SMS_Form.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__